import request from '@/utils/request'


// 门店列表
export function roomList(data) {
  return request({
    url: '/index/roomList',
    method: 'post',
    data
  })
}
// 监控列表
export function monitorInfo(data) {
  return request({
    url: '/index/monitorInfo',
    method: 'post',
    data
  })
}
// 监控列表
export function centerMonitor(data) {
  return request({
    url: '/Monitor/index',
    method: 'post',
    data
  })
}
// 强制锁门
export function powerOutage(data) {
  return request({
    url: '/Monitor/powerOutage',
    method: 'post',
    data
  })
}
// 开门
export function openDoor(data) {
  return request({
    url: '/Monitor/door',
    method: 'post',
    data
  })
}
// 异常断电
export function abnormalElectricity(data) {
  return request({
    url: '/Monitor/abnormal',
    method: 'post',
    data
  })
}
// 用户列表
export function userListIndex(data) {
  return request({
    url: '/user/index',
    method: 'post',
    data
  })
}
// 用户列表
export function UserMobile(data) {
  return request({
    url: '/user/UserMobile',
    method: 'post',
    data
  })
}

// 外卖订单
export function BuyOutOrder(data) {
  return request({
    url: '/BuyOutOrder/index',
    method: 'post',
    data
  })
}
// 外卖订单详情
export function BuyOutDetail(data) {
  return request({
    url: '/BuyOutOrder/detail',
    method: 'post',
    data
  })
}
// 日志列表
export function LogRecording(data) {
  return request({
    url: '/LogRecording/index',
    method: 'post',
    data
  })
}
// 拉黑
export function Userblock(data) {
  return request({
    url: '/user/Userblock',
    method: 'post',
    data
  })
}

// 视频回放
export function VideoPlayback(data) {
  return request({
    url: '/LogRecording/VideoPlayback',
    method: 'post',
    data
  })
}
// 自定义语音
export function Intercom(data) {
  return request({
    url: '/Monitor/Intercom',
    method: 'post',
    data
  })
}
// 语音列表
export function VicoList(data) {
  return request({
    url: '/Monitor/VicoData',
    method: 'post',
    data
  })
}
// 语音播放
export function playVico(data) {
  return request({
    url: '/Monitor/playVico',
    method: 'post',
    data
  })
}
// 警报
export function alarmIndex(data) {
  return request({
    url: '/Monitor/alarm',
    method: 'post',
    data
  })
}
// 对讲
export function talkback(data) {
  return request({
    url: '/Monitor/ActivateIntercom',
    method: 'post',
    data
  })
}
// 标记
export function TagUser(data) {
  return request({
    url: '/Monitor/TagUser',
    method: 'post',
    data
  })
}
// 稽查和订单列表
export function TagUserData(data) {
  return request({
    url: '/Monitor/TagUserData',
    method: 'post',
    data
  })
}
// 订单处理
export function handle(data) {
  return request({
    url: '/Monitor/handle',
    method: 'post',
    data
  })
}
// 订单详情
export function detailOrder(data) {
  return request({
    url: '/Monitor/detail',
    method: 'post',
    data
  })
}
// 删除日志
export function deleteLog(data) {
  return request({
    url: '/LogRecording/deleteLog',
    method: 'post',
    data
  })
}
// 首页操作日志
export function logIndex(data) {
  return request({
    url: '/LogRecording/logIndex',
    method: 'post',
    data
  })
}
// 操作类型
export function OperationType(data) {
  return request({
    url: '/LogRecording/OperationType',
    method: 'post',
    data
  })
}
// 首页收银
export function CashierOrder(data) {
  return request({
    url: '/BuyOutOrder/CashierOrder',
    method: 'post',
    data
  })
}
// 登录
export function AdminUser(data) {
  return request({
    // url: '/Monitor/sign',
    url: '/AdminUser/sign',
    method: 'post',
    data
  })
}
// 退出登录
export function signOut(data) {
  return request({
    url: '/AdminUser/sign_out',
    method: 'post',
    data
  })
}
// 上线或者离线状态
export function setOnline(data) {
  return request({
    url: '/AdminUser/setOnline',
    method: 'post',
    data
  })
}
// 右上脚名称
export function getInfoRight(data) {
  return request({
    url: '/AdminUser/getInfo',
    method: 'post',
    data
  })
}
// 门店监控转态变换
export function monitorStatus(data) {
  return request({
    url: '/index/monitorStatus',
    method: 'post',
    data
  })
}
// 门店指南
export function guidance(data) {
  return request({
    url: 'index/guidance',
    method: 'post',
    data
  })
}
// 门店数量
export function roomIdList(data) {
  return request({
    url: 'index/roomId',
    method: 'post',
    data
  })
}
// 发货方式
export function send_goods() {
  return request({
    url: "/system/dict/data/type/send_goods",
    method: "get",
  });
}
